import { AxiosResponse } from 'axios'
import axios from '@/services/axios'

export default abstract class AuthApi {
  public static route = process.env.VUE_APP_AUTH_BASE_URI
  public static ssoRoute = `${process.env.VUE_APP_CORE_BASE_URI}/auth/sso`

  public static async login(
    username: string,
    password: string,
  ): Promise<AxiosResponse> {
    return await axios.post(`${this.route}/login`, {
      username: username,
      password: password,
    })
  }

  public static async refreshToken(
    refreshToken: string,
  ): Promise<AxiosResponse> {
    return await axios.post(`${this.route}/refresh-token`, {
      refresh_token: refreshToken,
    })
  }

  public static async logout(refreshToken: string): Promise<AxiosResponse> {
    return await axios.post(`${this.route}/logout`, {
      refresh_token: refreshToken,
    })
  }

  public static async initializeSso(body: {
    arena_id: number | null
    hostname: string
    client_type: 'dashboard'
  }): Promise<AxiosResponse> {
    return await axios.post(`${this.ssoRoute}/initialize`, body)
  }

  public static async claimSso(pollUuid: string): Promise<AxiosResponse> {
    return await axios.post(`${this.ssoRoute}/${pollUuid}/claim`)
  }
}
